module.exports = __webpack_public_path__ + "media/images/site/insta-d90cef0dc4536526a1f60cfe31b633ef.svg";